import axios from "axios";
import getEndpoint from "../getEndpoint";

type UserInfo = {
  id: string;
  userName: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  address: string;
}

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function GetAllUsers() {
  const respone = await axios.get(`${getEndpoint()}/api/User/GetAll`, ngrokSkipWarning);
  return respone.data;
}

export async function GetAllUsersWithRole() {
  const respone = await axios.get(`${getEndpoint()}/api/User/GetAllUserWithRole`, ngrokSkipWarning);
  return respone.data;
}

export async function GetUserInfo(id: string){
  const response = await axios.get(`${getEndpoint()}/api/User/Get?id=${id}`, ngrokSkipWarning);
  return response.data;
}

export async function UpdateUserInfo(id: UserInfo) {
    const response = await axios.put(`${getEndpoint()}/api/User/Update`, id, ngrokSkipWarning);
    return response.data;
}

export async function GetUserInfoById(id: string){
  const response = await axios.get(`${getEndpoint()}/api/UserInfo/GetWithUserId?userId=${id}`, ngrokSkipWarning);
  return response.data;
}

export async function AddUserInfo(id: any){
  const response = await axios.post(`${getEndpoint()}/api/UserInfo/Add`, id, ngrokSkipWarning);
  return response.data;
}

export async function DeleteUser(id: string) {
  try {
    const response = await axios.delete(`${getEndpoint()}/api/User/Delete?id=${id}`, ngrokSkipWarning);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
}

export async function DeleteUserInfo(id:any) {
  const response = await axios.delete(`${getEndpoint()}/api/UserInfo/Delete?id=${id}`, {
      ...ngrokSkipWarning
  });
  return response.data;
}



